import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toggleModal } from "../store/actions/toggleModalActions";
import './UserDropDown.scss';

const selector = state => {
    const { modalState } = state;
    return {
        flag: modalState.flag,
        modal: modalState.modal
    };
};

const UserDropDown = props => {
    const { flag, modal } = useSelector(selector);
    const dispatch = useDispatch();
    const history = useHistory();

    const logOut = () => {
        sessionStorage.clear();
        dispatch(toggleModal(false, ''))
        history.push('/start');
    };

    return (
        <div className="userDropDownContainer" >
            <div className="userInfoContainer">
                <div className="userImage">
                    {props.user.firstName && props.user.lastName ? props.user.firstName[0].toUpperCase() + props.user.lastName[0].toUpperCase() : ''}
                </div>
                {!props.responsive && (
                    <div className="userInfo">
                        <p className="userName">{props.user.fullName}</p>
                    </div>
                )}
                <i
                    onClick={() => dispatch(toggleModal(!flag, 'menu'))}
                    className="material-icons dropDownIcon"
                    style={props.responsive ? {margin: '0 24px 0 0'} : null}
                >
                    {flag && modal === 'menu' ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                </i>
            </div>
            {flag && modal === 'menu' ?
                <ul className="dropDownMenu" onMouseLeave = {() => dispatch(toggleModal(!flag, 'menu'))}>
                    <li className="dropDownMenuItem" onClick={logOut}>
                        Log out
                    </li>
                </ul>
                : null
            }
        </div>
    );
};

export default UserDropDown;
